import { InMemoryCache } from "@apollo/client/core";

export const cache = new InMemoryCache({
  typePolicies: {
    CartType: {
      fields: {
        availableGifts: {
          merge: false,
        },
        availableShippingMethods: {
          merge: false,
        },
        availablePaymentMethods: {
          merge: false,
        },
        coupons: {
          merge: false,
        },
        discounts: {
          merge: false,
        },
        gifts: {
          merge: false,
        },
        items: {
          merge: false,
        },
        payments: {
          merge: false,
        },
        shipments: {
          merge: false,
        },
        validationErrors: {
          merge: false,
        },
      },
    },
    CartExtension: {
      fields: {
        items: {
          merge: false,
        },
        shipments: {
          merge: false,
        },
        payments: {
          merge: false,
        },
        validationErrors: {
          merge: false,
        },
        discounts: {
          merge: false,
        },
      },
    },
    CouponType: {
      keyFields: ["code"],
    },
    CurrencyType: {
      merge: false,
    },
    LineItemType: {
      fields: {
        validationErrors: {
          merge: false,
        },
      },
    },
    LineItemTypeExtension: {
      fields: {
        discounts: {
          merge: false,
        },
        configurationItems: {
          merge: false,
        },
        configurationItemsTL: {
          merge: false,
        },
        dynamicProperties: {
          merge: false,
        },
      },
    },
    ShipmentTypeExtension: {
      fields: {
        deliveryAddress: {
          merge: false,
        },
      },
    },
    PaymentTypeExtension: {
      fields: {
        billingAddress: {
          merge: false,
        },
      },
    },
    CartAddressTypeExtension: {
      keyFields: false,
    },
    ConfigurationItemTypeExtension: {
      keyFields: ["id"],
    },
    MoneyType: {
      merge: false,
    },
    PaymentMethodType: {
      keyFields: ["code"],
    },
    Product: {
      fields: {
        properties: {
          merge: false,
        },
      },
    },
    Property: {
      keyFields: false,
    },
    ValidationErrorType: {
      keyFields: ["errorCode", "objectId", "objectType"],
    },
    Query: {
      fields: {
        pushMessages: {
          merge(existing: Record<string, unknown>, incoming: Record<string, unknown>) {
            return { ...existing, ...incoming };
          },
        },
      },
    },
  },
});
